import { FC, lazy } from 'react';
import { ContractsParams } from 'src/apis/contract-management/types';
import { ContractManagementRequest } from 'src/apis/contract-management/use-contract-management';
import { Shipper } from 'src/apis/monolith/types';
import { useContracts } from 'src/pages/shippers/details/contracts/use-contracts';
import { useMemoOne } from 'use-memo-one';

const Page = lazy(() => import('./page'));

type ShipperContractsProps = {
  contractManagement: ContractManagementRequest;
  shipper: Shipper;
};

export const ShipperContracts: FC<ShipperContractsProps> = ({
  contractManagement,
  shipper,
}) => {
  const params = useMemoOne<ContractsParams>(
    () => ({ shipperId: [shipper.organizationId] }),
    [shipper]
  );
  const contracts = useContracts({ contractManagement, params });
  return <Page contracts={contracts} shipper={shipper} />;
};
